import React, { Component } from 'react';
import { Link } from 'react-router';
import { Table } from 'antd';
import moment from 'moment';
import util from '@util/index';

class TableCarry extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  columns = () => {
    const direction = ['转入', '转出'];
    return [
      {
        title: '账单结转编号',
        dataIndex: 'oldPayableNo',
        render: (text, record) => (
          <Link
            to={`/incubator/bill/${
              record.target === 0 ? record.oldPayableUuid : record.newPayableUuid
            }/detail`}
          >
            {record.target === 0 ? record.oldPayableNo : record.newPayableNo}
          </Link>
        ),
      },
      {
        title: '结转时间',
        dataIndex: 'createTime',
        render: (text, record) => (
          <span>{record.createTime ? moment.unix(text / 1000).format('YYYY-MM-DD') : null}</span>
        ),
      },
      {
        title: '收入类型',
        dataIndex: 'availNum',
        render: () => <span>押金</span>,
      },
      {
        title: '结转类型',
        dataIndex: 'target',
        render: text => <span>{direction[text]}</span>,
      },
      {
        title: '结转金额',
        dataIndex: 'price',
        render: text => <span>{text ? util.numberFormat(text) : ''}</span>,
      },
      {
        title: '状态',
        dataIndex: 'status',
        width: 100,
        render: text => <span>{text === 0 ? '待审核' : '已生效'}</span>,
      },
    ];
  };

  formatData = () => {
    const {
      dataSource: { turns, oldTurns },
    } = this.props;
    turns.map(item => {
      item.target = 0;
      return item;
    });
    oldTurns.map(item => {
      item.target = 1;
      return item;
    });
    return [...turns, ...oldTurns];
  };

  render() {
    const list = this.formatData();
    return <Table columns={this.columns()} dataSource={list} rowKey="uuid" />;
  }
}

export default TableCarry;



// WEBPACK FOOTER //
// ./src/components/incubator/bill/TableCarry.js